import * as Yup from "yup";

const phoneRegExp =
  /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/;

const yupValidatePhone = () => {
  return Yup.string().matches(phoneRegExp, "Has to be 10 digits.").nullable();
};

export { yupValidatePhone };
